import createWebStorage from '@doveconviene/sf-web-js-sdk/createWebStorage'

const webStorage = createWebStorage()

export default webStorage
